import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-bi-date-picker',
  templateUrl: './bi-date-picker.component.html',
  styleUrls: ['./bi-date-picker.component.scss']
})
export class BIDatePickerComponent {
  selectedDate: any;
  constructor(
    public dialogRef: MatDialogRef<BIDatePickerComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public RecivedData: any
  ) {

  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }
  onDateChange(value: Date) {
    this.selectedDate = value;
  }
  OK() {
    this.dialogRef.close(this.selectedDate);
  }
}
